import React, { useState } from 'react';
import DetailsCollapseButton from '../DetailsCollapseButton';
import { Content, Header, Section, TotalBadge } from './styles';

interface SectionCardProps {
  title: string | React.ReactNode;
  itemsCounter?: number;
  collapsed: boolean;
  children: React.ReactNode;
}

const SectionCard: React.FC<SectionCardProps> = ({
  title,
  itemsCounter,
  collapsed,
  children,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(collapsed);

  const handleToggleCollapse = () => {
    setIsCollapsed(prev => !prev);
  };

  return (
    <Section>
      <Header>
        {title}
        {!!itemsCounter && <TotalBadge>{itemsCounter}</TotalBadge>}
        <DetailsCollapseButton
          collapsed={isCollapsed}
          onClick={handleToggleCollapse}
        />
      </Header>
      {isCollapsed && <Content>{children}</Content>}
    </Section>
  );
};

export default SectionCard;
